import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// services
import { recoverEmpleadoDeleted } from '../../Services/empleadoService'

// Sweet alert
import Swal from 'sweetalert2'

// router
import { withRouter } from 'react-router-dom'

const ItemEmpleadoEliminado = ({ empleado, setIsLoad }) => {
    const recoverEmpleadoSubmit = (empleado) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                recoverEmpleadoDeleted(empleado.id.persona.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'El empleado fue recuperado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{empleado.id.persona.id}</th>
            <td>{empleado.id.persona.nombre}</td>
            <td>{empleado.id.persona.apellido}</td>
            <td>{empleado.id.persona.dni}</td>
            <td>{empleado.id.persona.correo}</td>
            <td>{empleado.id.persona.telefono}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverEmpleadoSubmit(empleado)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemEmpleadoEliminado)
